<template>
    <router-view :firebaseUser="firebaseUser" :user="user" :systemConfig="systemConfig" :userModel="userModel" :existingData="userModel"></router-view>
</template>

<script>
  export default {
    name: 'UserSection',
    props: {
      firebaseUser: {
        required: true
      },
      user: {
        required: true
      },
      systemConfig: {
        type: Object,
        required: true
      },
      userModel: {
        type: Object,
        required: true
      }
    },
  }
</script>

<style scoped>

</style>